import type { IconSize } from './types'

const sizeEm: Record<IconSize, number> = {
  xs: 0.75,
  sm: 0.875,
  '1x': 1,
  lg: 1.25,
  xl: 1.5,
  '2x': 2
}

export const toEm = (size?: IconSize, scale = 1) => `${(size ? sizeEm[size] : 1) * scale}em`
